import { useStorage } from '@vueuse/core'

export const useCompaniesStore = defineStore('companies', () => {
  // state
  const companies: Ref<Company[]> = useStorage('companies', [], localStorage)
  const companyId: Ref<number> = useStorage('cid', 0, localStorage)
  const subdomain: Ref<string> = useStorage('subdomain', '', localStorage)

  // mutations
  function setCompanies(tenantCompanies: Array<Company>) {
    companies.value = tenantCompanies
    companyId.value = companies.value[0].id
  }

  function setSubdomain(name: string) {
    subdomain.value = name
  }

  function reset() {
    companies.value = []
    companyId.value = 0
  }

  return { companies, setCompanies, setSubdomain, reset, companyId, subdomain }
})
